import BaseComponent from '@/components/base';
import { FontStyle } from '@/components/style';
import Style from '@/components/customization-details/customization-selector/style';

/**
 * CustomizationSelector component: allows users to select a customization option.
 *
 * Attributes:
 * - 'selection' (string): A JSON string representing the selected option.
 *   The JSON object should have the following format:
 *   {
 *     "dataKey": "string", // The key of the selected option.
 *     "name": "string"     // The name of the selected option.
 *   }
 * - 'options' (object): An object containing the customization options.
 */
export default class CustomizationSelector extends BaseComponent {
  static get observedAttributes() {
    return ['selection'];
  }

  afterMount() {
    this.shadowRoot
      .querySelectorAll('.customization-option')
      .forEach((option) => {
        option.addEventListener('click', (event) => {
          const selectedOption = {
            dataKey: option.dataset.key,
            name: option.textContent
          };
          this.setAttribute('selection', JSON.stringify(selectedOption));

          if (this.handleOptionClick) {
            this.handleOptionClick(option.dataset.key);
          }
        });
      });
  }

  /**
   * Retrieves the name of the current selection from the 'selection' attribute.
   *
   * @returns {string} The name of the current selection or an empty string if not available.
   */
  get selectionName() {
    return JSON.parse(this.getAttribute('selection'))?.name || '';
  }

  /**
   * Retrieves the key of the current selection from the 'selection' attribute.
   *
   * @returns {string} The key of the current selection or an empty string if not available.
   */
  get selectionKey() {
    return JSON.parse(this.getAttribute('selection'))?.dataKey || '';
  }

  render() {
    return `
      ${FontStyle}
      ${Style}
      <section>
        <p>New Selection: ${this.selectionName}</p>
        <ul class="customization-option-wrapper">
          ${this.data?.options?.value
            ?.map((option) => {
              return `
              <li data-key="${option.dataKey}" class="customization-option ${
                option.dataKey === this.selectionKey ? 'selected' : ''
              }">
                ${option.name}
              </li>`;
            })
            .join('')}
        </ul>
      </section>
    `;
  }
}
